import { css } from 'styled-components';

export const themeTokens = {
  checkoutTemplate: {
    wrapper: css``,
  },
};
